export const completePhoneRegex = /^(?:521\d{10}|57\d{10})$/;
export const phoneRegex = /^\d{10}$/;
export const dialCodeRegex = /^[1-9]\d{0,3}$/;

export const curpRegex =
/^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/;

export const passwordRegex =
    /(?:(?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/;

export const nameRegex = /^[ñíóáéú a-zA-Z ]+$/;
